import type { Variants, Transition } from 'framer-motion';
import { motion as motionTokens } from '@app/theme/tokens';

export const defaultTransition: Transition = {
  duration: motionTokens.duration,
  ease: [0.25, 0.1, 0.25, 1],
};

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: defaultTransition,
  },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: defaultTransition,
  },
};

export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.05,
    },
  },
};

export const cardHover = {
  y: motionTokens.cardHoverY,
  transition: defaultTransition,
};

export const buttonHover = {
  scale: motionTokens.buttonScale,
  transition: defaultTransition,
};
